export const isInsertLineVisible = (
	lineY: number,
	tableContainer: HTMLElement | null,
): boolean => {
	if (!tableContainer) {
		return false
	}

	const containerRect = tableContainer.getBoundingClientRect()
	const thead = tableContainer.querySelector('thead')
	const visibleTop = thead?.getBoundingClientRect().bottom ?? containerRect.top

	return lineY >= visibleTop && lineY <= containerRect.bottom
}
